<template>
	<div>
		
		<!-- <div class="scroll-progress primary-bg"></div> -->
		
		<!-- header -->
		<Header :isHome="true"></Header>
		
		<!-- banner -->
		<Banner style="width: 100vw;height: 100vh"></Banner>
		<!-- news -->
		<News></News>
		
		<!-- dicussion -->
		<Discussion></Discussion>
		
		<!-- supplier -->
		<Supplier></Supplier>
		
		<!-- solutions -->
		<Solutions></Solutions>
		
		<!-- footer -->
		<Footer></Footer>
	</div>
</template>

<script>
		import axios from 'axios'
		import Header from '/src/components/header.vue'
		import Banner from '/src/components/home/banner.vue'
		import News from '/src/components/home/news.vue'
		import Discussion from '/src/components/home/discussion.vue'
		import Supplier from '/src/components/home/supplier.vue'
		import Solutions from '/src/components/home/solutions.vue'
		import Footer from '/src/components/footer.vue'
		export default {
			data() {
				return {
				}
			},
			components: {
				Header,
				Banner,
				News,
				Discussion,
				Supplier,
				Solutions,
				Footer,
			},
			filters: {
	        },
			methods: {
			},
			created() {
				this.$bus.$emit('loading', true)
			},
			mounted() {
			}
		}

</script>

<style scoped>
</style>